import { get } from 'lodash'

export default function(award) {
  return {
    startDate: award.startDate,
    paymentState: {
      value: get(award, 'paymentState.value')
    },
    paymentStateChangeNote: get(award, 'participantRegistration.awardPayment.paymentNote'),
    isPaymentConfirmed: get(award, 'isPaymentConfirmed'),
    consentDeliveryDate: get(award, 'consentDeliveryDate'),
    isGivenSurveyConsent: get(award, 'isGivenSurveyConsent'),
    isConsentDeliveryConfirmed: get(award, 'isConsentDeliveryConfirmed'),
    consentDeliveryType: {
      value: get(award, 'consentDeliveryType.value')
    },
    participantRegistration: {
      parentRelationship: get(
        award,
        'participantRegistration.parentRelationship'
      ),
      parentFirstName: get(award, 'participantRegistration.parentFirstName'),
      parentLastName: get(award, 'participantRegistration.parentLastName'),
      parentEmail: get(award, 'participantRegistration.parentEmail'),
      parentPhone: get(award, 'participantRegistration.parentPhone')
    },
    awardLeader: {
      id: get(award, 'awardLeader.id')
    },
    note: get(award, 'note'),
    digitalBadgeUrl: get(award, 'digitalBadgeUrl'),
    isBulkLogEnabled: get(award, 'isBulkLogEnabled')
  }
}
